// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCrfzSvFTuIoeNcQfz8wkSKzxqWXwqLq44",
  authDomain: "portfolioweb-514b7.firebaseapp.com",
  projectId: "portfolioweb-514b7",
  storageBucket: "portfolioweb-514b7.appspot.com",
  messagingSenderId: "523905993762",
  appId: "1:523905993762:web:180b739144f6f4a6ffce7b",
  measurementId: "G-XPP3N2GJQZ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app);

export { app, analytics, storage };
